/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import gql from 'graphql-tag';

export const GET_NWP = gql`
  query GetApplication($applicationNo: String!) {
    getApplication(applicationNo: $applicationNo) {
      createdAt
      updatedAt
      appliedOn
      applicant
      applicantInfo {
        vuid
        userId
        email
        firstName
        middleName
        lastName
        criminalActivity
        noOfYearsWithCompany
        criminalActivityReason
        spouseWorkedInJamaica
        employed
        financiallyCapable
        maidenName
        middleName
        previouslyMarried
        typeOfIdentification
        passportIssuanceDate
        passportNumber
        passportExpiry
        salary
        spouseNationality
        trn
        addressOfEmployer {
          addressLine1
          city
          parish
          country
        }
        NIS
        email
        fullName
        emailVerified
        phoneVerified
        image
        bannerImg
        address {
          addressLine1
          addressLine2

          city

          zipcode
          country
          parish
        }
        intendedAddress {
          addressLine1
          addressLine2

          city

          zipcode
        }
        occupation
        bio
        primaryContactNo
        nationality

        createdAt
        alias
        childrenOrDependent
        gender
        maritalStatus
        passportExpiry
        otherNationality
        countryOfBirth
        passportNumber
        passportType
        previousEmployment
        justifcationForForeignEmployee
        placeOfBirth
        skills
        trn
        dateOfBirth
        declaration {
          selected
          value
        }
        permissionPeriod {
          from
          to
        }
        spouseName
        spouseNationality
        countryConvicted
        criminalOffence
        dateOfConviction
        natureOfOffence
        workedInJamaica
        workExperience {
          from
          to
          jobDuty
          nameOfOrganization
          refLetter
        }
        dependentInfo {
          dependentType
          name
          passportNumber
          relationship
          age
          documents {
            expiry
            fileType
            name
            src
            type
          }
          gender
          nationality
        }
        isLastNameExist
        natureOfBusiness
        natureOfProfessionalActivity
        isDependentExist
        dateOfEntry
        name
        otherIncomeSource
        notfinanciallyCapableReason
        portOfEntry
        employmentStatus
        employmentAddress {
          addressLine1
          addressLine2

          city

          parish
          zipcode
          country
        }
        nameOfEmployer
        lastEmployer {
          name
          address {
            addressLine1
            addressLine2
            city
            parish
          }
          primaryContactNo
          credentialNo
          wpExpiry
        }
        qualification {
          degree
          dateReceived
        }
        spouseLastEmployer {
          name
          address {
            addressLine1
            addressLine2
            city
            parish
          }
          credentialNo
          wpExpiry
        }
      }
      applicationNo
      appliedBy
      documents {
        name
        type
        src
        fileType
        expiry
      }
      employerInfo {
        orgId
        name
        tradingName
        email
        registrationNo
        trn
        incorporationDate
        type
        dateOfRegistration
        fax
        operatingAddress {
          addressLine1
          addressLine2

          city

          zipcode
          country
          parish
        }
        natureOfBusiness
        website
        primaryContactNo
        address {
          addressLine1
          addressLine2

          city

          zipcode
          country
          parish
        }
        logo
        status
        isSubsidiary
        workPermitIsInRelationTo
        saffCompsition {
          citizenship
          professional
          clerksOrServiceWorker
          skilledWorkers
          plantAndMachineOperators
          elementaryOccupations
          total
        }
        credentialNo
        wpExpiry
        tccExpiryDate
        tccNumber
      }
      jobInfo {
        JobTitle
        description
        necessaryQualification
        salaryOffered
        allowances {
          house
          car
          entertainment
          other
        }
        currency
        stepsForJaimacan {
          internalRecruitment

          didJamaicanApply
          appliedCandidates
          noStepTaken
          reasonNoneHired
          byAdvertisement
        }
        JobId
        benefitsReceived
        jobDuties
        registeredLMIS
        workingHours
      }
      status
      type
      dependentInfo {
        dependentType
        name
        relationship
        passportNumber
        age
        gender
        nationality
        documents {
          name
          type
          src
          fileType
          expiry
        }
      }
      studentEducationDetail {
        educationType
        degreeOrCertificate
        instituteName
        instituteAddress {
          addressLine1
          addressLine2

          city

          parish
          zipcode
          country
        }
        primaryContactNo
        email
      }
    }
  }
`;
